import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { ApiService } from 'src/app/services/api.service';
import { AuthGuard, AuthService, Profile } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { EnumToKeyPipe } from 'src/app/services/wording-enum-pipe';
import { GetUserResponse, GetUserResponseExploitation, UpdateUserRequest } from '../../services/dtos';

type ValidationError = 'noRoles';
@Component({
	templateUrl: './user-page.component.html',
	styleUrls: ['./user-page.component.scss'],
	providers: [ConfirmationService, NotificationService, EnumToKeyPipe, TranslatePipe],
})
export class UserPageComponent implements OnInit {
	errorRoleType: ValidationError | null = null;
	user: GetUserResponse;
	profile: Profile;
	userRole: string;

	exploitations: GetUserResponseExploitation[];
	selectedExploitation: GetUserResponseExploitation;

	editExploitationAccessDialog: boolean;

	currentUserDraft: UpdateUserRequest;
	userUpdateDialog: boolean;

	constructor(
		private apiService: ApiService,
		private authGuard: AuthGuard,
		private authService: AuthService,
		private router: Router,
		private route: ActivatedRoute,
		private confirmationService: ConfirmationService,
		private notificationService: NotificationService,
		private enumToKeyPipe: EnumToKeyPipe,
		private translatePipe: TranslatePipe,
	) {}

	ngOnInit() {
		this.authService.loadUserProfile().then((profile: Profile) => {
			this.profile = profile;
		});
		this.updateUserPage();
	}

	updateUserPage() {
		this.apiService.exploitation_getUser(this.route.snapshot.paramMap.get('id')).subscribe((user) => {
			this.user = user;
			this.exploitations = user.exploitations;
			const userRoleList = user.roles.map((str) =>
				this.translatePipe.transform(this.enumToKeyPipe.transform(str)),
			);
			this.userRole = userRoleList.join(' & ');
		});
	}

	hideAllDialog() {
		this.editExploitationAccessDialog = false;
		this.userUpdateDialog = false;
	}

	editAccess(exploitation: GetUserResponseExploitation) {
		this.selectedExploitation = { ...exploitation };
		this.editExploitationAccessDialog = true;
	}

	updateUserRoles() {
		this.errorRoleType = null;
		this.currentUserDraft = { email: this.user.email, enabled: true, roles: this.user.roles };
		this.userUpdateDialog = true;
	}

	private validateUserUpdateDraft() {
		const validateRoles = this.validateUserUpdateRoles();
		return validateRoles;
	}

	private validateUserUpdateRoles() {
		const hasRoles = this.currentUserDraft.roles.length !== 0;
		if (!hasRoles) {
			this.errorRoleType = 'noRoles';
			return false;
		}
		return true;
	}

	updateUser() {
		if (this.validateUserUpdateDraft()) {
			this.userUpdateDialog = false;
			this.apiService.user_putUser(this.currentUserDraft, this.user.id).subscribe(
				() => {
					this.notificationService.notifySuccess('Rôles changés');
					this.updateUserPage();
				},
				(err) => {
					this.notificationService.notifyError(err.statusText);
				},
			);
		}
	}

	saveExploitationAccess() {
		this.apiService
			.exploitation_putUserAccess(
				this.selectedExploitation.userExploitationId,
				this.selectedExploitation.niveauAcces,
			)
			.subscribe(
				() => {
					this.notificationService.notifySuccess('Droits utilisateur mis à jour');
					this.updateUserPage();
				},
				(err) => {
					this.notificationService.notifyError(err.statusText);
				},
			);

		this.editExploitationAccessDialog = false;
	}

	deleteAccess(exploitation: GetUserResponseExploitation) {
		this.confirmationService.confirm({
			message: "Êtes vous sûr de vouloir supprimer l'accès à ce cheptel pour " + this.user.email + ' ?',
			header: 'Confirmer',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.apiService.exploitation_deleteUserAccess(exploitation.userExploitationId).subscribe(
					() => {
						this.notificationService.notifySuccess('Droits enlevés');
						this.updateUserPage();
					},
					(err) => {
						this.notificationService.notifyError(err.statusText);
					},
				);
			},
		});
	}

	deleteUser() {
		this.confirmationService.confirm({
			message: "Êtes vous sûr de vouloir supprimer l'utilisateur " + this.user.email + ' ?',
			header: 'Confirmer',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.apiService.user_deleteUser(this.user.id).subscribe(
					() => {
						this.notificationService.notifySuccess('Utilisateur supprimé');
						this.router.navigateByUrl(`inventaire/utilisateur`);
					},
					(err) => {
						this.notificationService.notifyError(err.statusText);
					},
				);
			},
		});
	}
}
